import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';


const createMeasurements = async (payload, old_date, old_growth_rate) => {

    const { data } = await api.post('/measurements/', payload);

    return data;
};

export const useCreateMeasurements = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({ payload }) => createMeasurements(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('measurements');
        },
        ...queryOptions
    });
};

const fetchMeasurements = async property_id => {
    const { data } = await api.get(`/measurements/${property_id}`);

    return data;
};

export const useMeasurements = (property_id, type, queryOptions = {}) => (

    useQuery(
        ['measurements', property_id],
        () => fetchMeasurements(property_id, type),
        {
            staleTime: 0,
            ...queryOptions
        }
    )
);
